import { render, staticRenderFns } from "./mailSetting.vue?vue&type=template&id=4e1f1936&scoped=true"
import script from "./mailSetting.vue?vue&type=script&lang=ts"
export * from "./mailSetting.vue?vue&type=script&lang=ts"
import style0 from "./mailSetting.vue?vue&type=style&index=0&id=4e1f1936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f1936",
  null
  
)

export default component.exports